import { Injectable, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { JobLogsDialogData } from '../model';
import { JobLogsDialogComponent } from './job-logs-dialog.component';

@Injectable()
export class JobLogsDialogService {
  constructor(private readonly dialog: MatDialog, private readonly injector: Injector) {}

  open(data: JobLogsDialogData): Observable<void> {
    return this.dialog
      .open(JobLogsDialogComponent, {
        data,
        width: '80vw',
        height: '80vh',
        panelClass: ['full-screen-popup'],
        injector: this.injector,
      })
      .afterClosed();
  }
}
